<template>
  <v-app id="inspire">
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card class="elevation-12">
              <v-toolbar color="indigo" dark flat>
                <v-toolbar-title>Login to DeltaCert</v-toolbar-title>
                <v-spacer />
                <v-icon>mdi-diamond-stone</v-icon>
              </v-toolbar>
              <v-card-text>
                <v-form
                  @submit.prevent="login(inputs)"
                  ref="form"
                  v-model="valid"
                >
                  <v-text-field
                    v-model="inputs.username"
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    :rules="[v => !!v || 'Email is required']"
                    required
                  />

                  <v-text-field
                    v-model="inputs.password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    :rules="[v => !!v || 'Password is required']"
                    required
                  />

                  <v-btn type="submit" v-show="false">Login</v-btn>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="indigo"
                  @click="login(inputs)"
                  :disabled="!valid"
                  :dark="valid"
                  >Login</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-snackbar v-model="snackbar">
      Error in login details
      <v-btn color="red" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      inputs: {
        username: "",
        password: ""
      },
      valid: false,
      snackbar: false
    };
  },
  methods: {
    login({ username, password }) {
      this.$store
        .dispatch("auth/login", { username, password })
        .then(() => this.$router.push("/"))
        .then(
          success => {},
          failure => {
            this.snackbar = true;
          }
        );
    }
  }
};
</script>
